var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart_data"},[_c('div',{staticClass:"nodata_wrap"},[_c('div',{staticClass:"img_wrap"},[_c('img',{attrs:{"src":require("../../assets/images/commom/nodata-tip.png"),"alt":""}})]),_c('p',[_vm._v("现在还没有数据哦！")])])])
}]

export { render, staticRenderFns }